import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-49f3befd")

_pushScopeId("data-v-49f3befd")
const _hoisted_1 = { class: "customer_page" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 客户360 VID 表链接 ")
const _hoisted_5 = { class: "vid_title" }
const _hoisted_6 = {
  class: "common_popup_ul",
  style: {"width":"80vw"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_empty = _resolveComponent("van-empty")
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_loading = _resolveComponent("van-loading")
  const _component_info = _resolveComponent("info")
  const _component_van_popup = _resolveComponent("van-popup")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.state.showContent)
      ? (_openBlock(), _createBlock(_component_van_empty, {
          key: 0,
          description: "该CID无相关VID，请确认客户是否有创建项目"
        }))
      : (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_van_button, {
              plain: "",
              icon: "share",
              type: "primary",
              size: "mini",
              onClick: _ctx.jumpToArcher
            }, null, 8, ["onClick"])
          ]),
          _createVNode("div", _hoisted_5, [
            _createTextVNode(" VID : " + _toDisplayString(_ctx.state.vid) + " ", 1),
            _createVNode(_component_van_button, {
              plain: "",
              icon: "exchange",
              type: "primary",
              size: "mini",
              onClick: _ctx.openPopup
            }, null, 8, ["onClick"])
          ]),
          (_ctx.state.loading)
            ? (_openBlock(), _createBlock(_component_van_loading, {
                key: 0,
                type: "spinner",
                size: "40",
                style: {"margin-top":"40px"}
              }))
            : (_openBlock(), _createBlock(_component_info, {
                key: 1,
                data: _ctx.state.projectInfo || [],
                title: "项目表关键信息"
              }, null, 8, ["data"]))
        ])),
    _createVNode(_component_van_popup, {
      show: _ctx.state.popupShow,
      onClickOverlay: _ctx.closePopup,
      position: "right"
    }, {
      default: _withId(() => [
        _createVNode("ul", _hoisted_6, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.vidOptions, (v, i) => {
            return (_openBlock(), _createBlock(_Fragment, null, [
              (v.value === _ctx.state.vid)
                ? (_openBlock(), _createBlock("li", {
                    key: v.value,
                    class: "active",
                    onClick: ($event: any) => (_ctx.selectVid(v.value))
                  }, _toDisplayString(v.text), 9, ["onClick"]))
                : (_openBlock(), _createBlock("li", {
                    key: v.value + i,
                    onClick: ($event: any) => (_ctx.selectVid(v.value))
                  }, _toDisplayString(v.text), 9, ["onClick"]))
            ], 64))
          }), 256))
        ])
      ]),
      _: 1
    }, 8, ["show", "onClickOverlay"])
  ]))
})